import { useState, useEffect } from "react";
import "./styles/payinfo.scss";
import Address from "./component/address";
import axios from "axios";
import { backend } from '../../components/apipath';
import { useAuth } from "../../pages/login/AuthProvider";
import { usePayment } from "../../components/PaymentContext";
import { useNavigate } from "react-router-dom";

function Payinfo() {
  const { step, setStep } = usePayment();
  const [showCourses , setShowCourses] = useState(false);
  const { mem_id, authorized } = useAuth();
  const navigate = useNavigate();

  const PARENT_ID = {
    CPA: "1",
    CMA: "2",
    EA:  "3",
    CPE: "4",
    BRIDGE: "5",
    UT:  "6",
    RP:  "7",
    CIA:  "8",
  };
// ===== 舊生續購：加購項目 options =====
const cpaAddonOptions = [
  { id: "ua_extend_18000", label: "Unlimited Access 持續展延 - NT$18,000" },
  { id: "final_review_8000", label: "Becker CPA Final Review - 單科 NT$8,000" },
  { id: "chinese_course_1500", label: "中文課程 - 單堂3小時 NT$1,500" },
  { id: "consult_1500", label: "顧問諮詢 - 單次20分鐘 NT$1,500" },
  { id: "textbook_2500", label: "紙本 Becker 原文教科書 - 單本 NT$2,500 (請於備註欄註明數量、科目)" },
];

// ===== 舊生續購：中文面授班科目 options =====
const chineseInpersonSubjects = [
  { id: "FAR", label: "FAR" },
  { id: "AUD", label: "AUD" },
  { id: "REG", label: "REG" },
  // Discipline
  { id: "BAR", label: "Discipline (BAR/ISC/TCP) - BAR" },
  { id: "ISC", label: "Discipline (BAR/ISC/TCP) - ISC" },
  { id: "TCP", label: "Discipline (BAR/ISC/TCP) - TCP" },
];
  // 產品父層
  const [parentId, setParentId] = useState("");
  // CPA 與 EA 都可選「現場面授」
  const [allowOnsite, setAllowOnsite] = useState(false);
  // 僅 CMA 需要顯示/驗證額外欄位
  const [isCMA, setIsCMA] = useState(false);
  const [isCPA, setIsCPA] = useState(false);
  const [isEA,  setIsEA]  = useState(false);
  const [isRP,  setIsRP]  = useState(false);
  const [isCIA, setIsCIA] = useState(false);

  // ===== 共用：日期解析/驗證 =====
  const parseYMD = (s = "") => {
    const m = s.trim().match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})$/);
    if (!m) return null;
    const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
    const dt = new Date(Date.UTC(y, mo - 1, d));
    if (
      dt.getUTCFullYear() !== y ||
      dt.getUTCMonth() + 1 !== mo ||
      dt.getUTCDate() !== d
    ) return null;
    return { y, mo, d, date: dt };
  };

  const isValidDateInRange = (s, minISO, maxISO) => {
    const p = parseYMD(s);
    if (!p) return false;
    const x = p.date.getTime();
    const min = parseYMD(minISO)?.date.getTime();
    const max = parseYMD(maxISO)?.date.getTime();
    if (min != null && x < min) return false;
    if (max != null && x > max) return false;
    return true;
  };

  const addDaysISO = (baseISO, days) => {
    const p = parseYMD(baseISO);
    if (!p) return baseISO;
    const t = new Date(p.date.getTime());
    t.setUTCDate(t.getUTCDate() + days);
    const y = t.getUTCFullYear();
    const m = String(t.getUTCMonth() + 1).padStart(2, '0');
    const d = String(t.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  // 產品型別：BASIC(=CPA/CMA/EA)、CPE、BRIDGE、UT
  const [productType, setProductType] = useState("BASIC");

  // 學分班課程選單
  const [bridgeCourseOptions, setBridgeCourseOptions] = useState([]);

  // ===== 表單資料 =====
  const [formData, setFormData] = useState({
    name: "",
    fname: "",
    lname: "",
    email: "",
    phone: "",
    idIdentity: "",
    school: "",
    major: "",
    address: "",
    tax_num: "",
    company: "",
    status: "",
    jobtitle:"",
    workyear:"",
    reason: "",
    industry:"",
    // 注意：deliver/book 改成「陣列」
    deliver: [],
    course: [],
    book: [],
    info_way: [],

    // CPE
    cpe_email: "",
    cpe_activation_confirm: false,
    cpe_company_name: "",

    // BRIDGE
    bridge_birthdate: "",
    bridge_courses: [],

    // UT 專屬
    ut_activation_date: "",      // 指定啟用日（購買日起 30 天內）
    ut_reasons: [], 
    
    // RP 專屬
    cpa_addons: [],
    chinese_class_option: "",
    chinese_inperson_subjects: [],

  });

  const [errors, setErrors] = useState({
    name: "",
    fname:"",
    lname:"",
    email: "",
    phone: "",
    idIdentity: "",
    school: "",
    major: "",
    address: "",
    status: "",
    jobtitle:"",
    workyear: "",
    reason: "",
    industry:"",
    deliver: "",
    course: "",
    book: "",
    info_way: "",
    tax_num: "",
    // CPE
    cpe_email: "",
    cpe_activation_confirm: "",
    cpe_company_name: "",
    // BRIDGE
    bridge_birthdate: "",
    bridge_courses: "",
    // UT
    ut_activation_date: "",
    ut_reasons: "",
  });

  useEffect(() => {
  const pid = localStorage.getItem("selectedParentId") || "";
  setParentId(pid);

  const onsite = pid === PARENT_ID.CPA || pid === PARENT_ID.EA; 
  setAllowOnsite(onsite);
  setIsCMA(pid === PARENT_ID.CMA);
  setIsCPA(pid === PARENT_ID.CPA);
  setIsEA(pid === PARENT_ID.EA);
  setIsRP(pid === PARENT_ID.RP);

  const cia = pid === PARENT_ID.CIA;
  setIsCIA(cia);

  if (pid === PARENT_ID.CPE) setProductType("CPE");
  else if (pid === PARENT_ID.BRIDGE) setProductType("BRIDGE");
  else if (pid === PARENT_ID.UT) setProductType("UT");
  else if (pid === PARENT_ID.RP) setProductType("RP");
  else setProductType("BASIC");

  // 不是 CPA / EA：移除「現場面授」
  if (!onsite) {
    setFormData(prev => {
      const filtered = (Array.isArray(prev.course) ? prev.course : []).filter(v => v !== "現場面授");
      const next = { ...prev, course: filtered };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  }

  if (cia) {
    setFormData(prev => {
      const next = { ...prev, course: ["雲端教室"] };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  }
}, []);



  // 取得學分班課程
  useEffect(() => {
    if (productType !== "BRIDGE") return;
    let cancelled = false;
    (async () => {
      try {
        const url = `${backend}course/csu-course`;
        const { data } = await axios.get(url);
        const rows = Array.isArray(data) ? data : (Array.isArray(data?.rows) ? data.rows : []);
        const opts = rows.map(d => ({
          id: String(d.id ?? d.csu_course_id ?? ""),
          label: `${d.code ?? ""} - ${(d.title ?? d.content ?? "").trim()}`
                  + `${d.credit ? `（${Number(d.credit)} 學分）` : ""}`
                  + `${d.cpa_range ? `｜${d.cpa_range}` : ""}`,
        })).filter(o => o.id && o.label);
        if (!cancelled) setBridgeCourseOptions(opts);
      } catch (e) {
        console.error("Failed to load csu courses", e);
        if (!cancelled) setBridgeCourseOptions([]);
      }
    })();
    return () => { cancelled = true; };
  }, [productType, backend]);

  // 初始載入 localStorage.formData 合併
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("formData") || "{}");
    setFormData(prev => ({
      ...prev,
      ...stored,
      // 標準化為陣列
      course: Array.isArray(stored.course)
        ? stored.course.filter(Boolean)
        : (typeof stored.course === 'string' ? stored.course.split(',').map(s => s.trim()).filter(Boolean) : []),
      book: Array.isArray(stored.book)
        ? stored.book.filter(Boolean)
        : (typeof stored.book === 'string' ? stored.book.split(',').map(s => s.trim()).filter(Boolean) : []),
      deliver: Array.isArray(stored.deliver)
        ? stored.deliver.filter(Boolean)
        : (typeof stored.deliver === 'string' ? stored.deliver.split(',').map(s => s.trim()).filter(Boolean) : []),
      info_way: Array.isArray(stored.info_way)
        ? stored.info_way.filter(Boolean)
        : (typeof stored.info_way === 'string' ? stored.info_way.split(',').map(s => s.trim()).filter(Boolean) : []),
      cpe_email: stored.cpe_email || "",
      cpe_activation_confirm: Boolean(stored.cpe_activation_confirm),
      // UT
      ut_reasons: Array.isArray(stored.ut_reasons)
        ? stored.ut_reasons.filter(Boolean)
        : (typeof stored.ut_reasons === 'string' ? stored.ut_reasons.split(',').map(s => s.trim()).filter(Boolean) : []),
      cpa_addons: Array.isArray(stored.cpa_addons)
        ? stored.cpa_addons.filter(Boolean)
        : (typeof stored.cpa_addons === 'string' ? stored.cpa_addons.split(',').map(s => s.trim()).filter(Boolean) : []),

      chinese_inperson_subjects: Array.isArray(stored.chinese_inperson_subjects)
        ? stored.chinese_inperson_subjects.filter(Boolean)
        : (typeof stored.chinese_inperson_subjects === 'string' ? stored.chinese_inperson_subjects.split(',').map(s => s.trim()).filter(Boolean) : []),

      chinese_class_option: stored.chinese_class_option || "",

    }));
  }, []);

  // 權限與流程檢查
  useEffect(() => {
    const selectedPlan = localStorage.getItem("selectedPlan");
    if (!authorized) {
      navigate("/member/memberlogin");
    } else if (step < 1 || !selectedPlan) {
      navigate("/registration");
    }
  }, [authorized, step, navigate]);

  // 讀會員資料預填
  useEffect(() => {
    const fetchMemberData = async () => {
      try {
        if (!mem_id) return;
        const response = await axios.get(`${backend}member/memareaData/${mem_id}`);
        if (response.data && response.data.length > 0) {
          const m = response.data[0];
          setFormData(prev => ({
            ...prev,
            name: m.chinese_name || "",
            fname: m.first_name || "",
            lname: m.last_name || "",
            email: m.email || "",
            phone: m.phone_num || "",
            school: m.school || "",
            major: m.major || "",
            address: m.address || "",
            status: m.status || "",
            idIdentity: m.id_num || "",
            tax_num: m.tax_num || "",
            company: m.company || "",
            workyear: m.workyear || "",
            jobtitle: m.jobtitle || "",
            industry: m.industry || "",
            reason: m.reason || "",
            // 陣列化
            course: Array.isArray(m.course)
              ? m.course
              : (typeof m.course === 'string' ? m.course.split(',').map(s => s.trim()).filter(Boolean) : []),
            book: Array.isArray(m.book)
              ? m.book
              : (typeof m.book === 'string' ? m.book.split(',').map(s => s.trim()).filter(Boolean) : []),
            deliver: Array.isArray(m.deliver)
              ? m.deliver
              : (typeof m.deliver === 'string' ? m.deliver.split(',').map(s => s.trim()).filter(Boolean) : []),
            info_way: Array.isArray(m.info_way)
              ? m.info_way
              : (typeof m.info_way === 'string' ? m.info_way.split(',').map(s => s.trim()).filter(Boolean) : []),
            // CPE
            cpe_company_name: m.company || "",
            cpe_email: (m.cpe_email || m.email || ""),
          }));
        }
      } catch (error) {
        console.error("Failed to fetch member data", error);
      }
    };
    fetchMemberData();
  }, [mem_id, backend]);

  // ========== 事件處理 ==========
  const handleCourseSelection = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.course || []);
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, course: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // 書本勾選（CPA only）
  const handleBookChange = (e) => {
    const value = e.target.value;
    setFormData(prev => {
      const prevBooks = Array.isArray(prev?.book) ? prev.book : [];
      const nextBooks = prevBooks.includes(value)
        ? prevBooks.filter(v => v !== value)
        : [...prevBooks, value];
      const next = { ...(prev || {}), book: nextBooks };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // 是否加購紙本（CPA only）
  const handleAddBookToggle = (wantBooks) => {
    setShowCourses(wantBooks);
    setFormData(prev => {
      const prevObj = prev || {};
      const next = {
        ...prevObj,
        book: wantBooks ? (Array.isArray(prevObj.book) ? prevObj.book : []) : [],
        deliver: wantBooks ? (Array.isArray(prevObj.deliver) ? prevObj.deliver : []) : [],
      };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // 切換快遞/自取（CPA only）
  const handleDeliverChange = (value) => {
    setFormData(prev => {
      const next = { ...(prev || {}), deliver: [value] };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleinfoChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.info_way || []);
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, info_way: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  const handleBridgeCourseChange = (e) => {
    const { value, checked } = e.target;
    const id = String(value);
    setFormData(prev => {
      const now = new Set(prev.bridge_courses?.map(String) || []);
      if (checked) now.add(id);
      else now.delete(id);
      const next = { ...prev, bridge_courses: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // UT：原因（checkbox 複選）
  const handleUTReasonChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const now = new Set(prev.ut_reasons || []);
      if (checked) now.add(value);
      else now.delete(value);
      const next = { ...prev, ut_reasons: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // ===== RP：加購項目 checkbox（cpa_addons）=====
  const handleCpaAddonChange = (e) => {
    const value = String(e.target.value);
    const checked = e.target.checked;

    setFormData(prev => {
      const now = new Set((prev.cpa_addons || []).map(String));
      if (checked) now.add(value);
      else now.delete(value);

      const next = { ...prev, cpa_addons: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // ===== RP：中文面授班選項 radio（chinese_class_option）=====
  const handleChineseClassOptionChange = (e) => {
    const option = e.target.value;

    setFormData(prev => {
      const next = {
        ...prev,
        chinese_class_option: option,
        // 不是進班就清空科目
        chinese_inperson_subjects: option === "inperson" ? (prev.chinese_inperson_subjects || []) : [],
      };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // ===== RP：中文面授班科目 checkbox（chinese_inperson_subjects）=====
  const handleChineseInpersonSubjectChange = (e) => {
    const value = String(e.target.value);
    const checked = e.target.checked;

    setFormData(prev => {
      const now = new Set((prev.chinese_inperson_subjects || []).map(String));
      if (checked) now.add(value);
      else now.delete(value);

      const next = { ...prev, chinese_inperson_subjects: Array.from(now) };
      localStorage.setItem("formData", JSON.stringify(next));
      return next;
    });
  };

  // 身分證驗證
  const validateTWID = (id) => {
    const letters = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
    const regex = /^[A-Z][12]\d{8}$/;
    if (!regex.test(id)) return false;
    const firstLetter = id.charAt(0);
    const index = letters.indexOf(firstLetter) + 10;
    const n1 = Math.floor(index / 10);
    const n2 = index % 10;
    const numbers = [n1, n2, ...id.substr(1).split('').map(Number)];
    const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
    let sum = 0;
    for (let i = 0; i < numbers.length; i++) sum += numbers[i] * weights[i];
    return sum % 10 === 0;
  };

  // 送出
  const handleSubmit = async (e) => {
    e.preventDefault();

    let formValid = true;
    const newErrors = {};
    const chineseNameRegex = /^[\u4e00-\u9fa5]{2,}$/;
    const englishNameRegex = /^[a-zA-Z\s\-]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^(\+?886\-?|0)?9\d{8}$/;
    const taxIdRegex = /^\d{8}$/;

    // 基本必填
    const requiredBase = ["name", "fname", "lname", "email", "phone", "idIdentity", "school", "status", "info_way", "address"];
    requiredBase.forEach((field) => {
      const val = formData[field];
      if (!val || (Array.isArray(val) && val.length === 0)) {
        newErrors[field] = "此欄位是必填欄位";
        formValid = false;
      }
    });

    // 若 CPA 選加購書（showCourses=true），且選了「快遞」，需至少勾選一本書
    const isCourier = Array.isArray(formData.deliver) && formData.deliver.includes("快遞");
    if (parentId === PARENT_ID.CPA && showCourses && isCourier) {
      if (!Array.isArray(formData.book) || formData.book.length === 0) {
        newErrors.book = "請選擇快遞科目";
        formValid = false;
      }
    }


    // 上課方式必填
    if (!isCIA && productType !== "CPE" && (!Array.isArray(formData.course) || formData.course.length === 0)) {
      newErrors.course = "請選擇上課方式";
      formValid = false;
    }

    // CMA 額外必填（沿用原設計）
    if (productType === "BASIC" && isCMA) {
      if (!formData.workyear) { newErrors.workyear = "請填寫工作年資"; formValid = false; }
      if (!formData.reason)   { newErrors.reason   = "請填寫考照原因"; formValid = false; }
      if (!formData.jobtitle) { newErrors.jobtitle = "請填寫在職者職稱"; formValid = false; }
      if (!formData.industry) { newErrors.industry = "請填寫所屬產業"; formValid = false; }
    }

    // CPE 額外必填
    if (productType === "CPE") {
      
      if (!formData.cpe_activation_confirm) { // ⬅︎ 取代日期驗證
        newErrors.cpe_activation_confirm = "請勾選已了解啟用說明";
        formValid = false;
      }
      if (!formData.cpe_company_name || formData.cpe_company_name.trim() === "") {
        newErrors.cpe_company_name = "請填寫所屬公司行號名稱";
        formValid = false;
      }
      
    }

    // BRIDGE 額外必填
    if (productType === "BRIDGE") {
      const bday = (formData.bridge_birthdate || '').trim();
      const todayISO = new Date().toISOString().slice(0, 10);
      const minISO = "1900-01-01";
      if (!isValidDateInRange(bday, minISO, todayISO)) {
        newErrors.bridge_birthdate = "請輸入真實存在的日期（YYYY-MM-DD / YYYY/MM/DD），且需介於 1900-01-01 ~ 今天";
        formValid = false;
      }
      if (!Array.isArray(formData.bridge_courses) || formData.bridge_courses.length === 0) {
        newErrors.bridge_courses = "請至少選擇一個學分班課程";
        formValid = false;
      }
    }

    // UT 額外必填
    if (productType === "UT") {
      // 啟用日：購買日起 30 天內（此處以「今天」視為購買日）
      const todayISO = new Date().toISOString().slice(0, 10);
      const maxISO = addDaysISO(todayISO, 30);
      const utDate = (formData.ut_activation_date || '').trim();
      if (!utDate) {
        newErrors.ut_activation_date = "請指定啟用日";
        formValid = false;
      } else if (!isValidDateInRange(utDate, todayISO, maxISO)) {
        newErrors.ut_activation_date = `啟用日需為 ${todayISO} 至 ${maxISO} 之間`;
        formValid = false;
      }

      // 選購原因：至少一項
      if (!Array.isArray(formData.ut_reasons) || formData.ut_reasons.length === 0) {
        newErrors.ut_reasons = "請至少勾選一項選購原因";
        formValid = false;
      }
    }

    // RP 額外必填（你要不要必填 cpa_addons 取決於規則；我先做「非必填」）
    if (productType === "RP") {
      if (!formData.chinese_class_option) {
        newErrors.chinese_class_option = "請選擇中文課程方式";
        formValid = false;
      }

      if (formData.chinese_class_option === "inperson") {
        if (!Array.isArray(formData.chinese_inperson_subjects) || formData.chinese_inperson_subjects.length === 0) {
          newErrors.chinese_inperson_subjects = "請至少勾選一個欲加入中文面授班的科目";
          formValid = false;
        }
      }
    }

    // 其餘格式驗證
    if (formData.name && !chineseNameRegex.test(formData.name.trim())) {
      newErrors.name = "請輸入 2 個以上的中文姓名";
      formValid = false;
    }
    if (formData.fname && !englishNameRegex.test(formData.fname.trim())) {
      newErrors.fname = "First name 請輸入英文";
      formValid = false;
    }
    if (formData.lname && !englishNameRegex.test(formData.lname.trim())) {
      newErrors.lname = "Last name 請輸入英文";
      formValid = false;
    }
    if (formData.email && !emailRegex.test(formData.email.trim())) {
      newErrors.email = "請輸入正確的信箱";
      formValid = false;
    }
    if (formData.phone && !phoneRegex.test(formData.phone.trim())) {
      newErrors.phone = "請輸入正確的手機號碼";
      formValid = false;
    }
    if (formData.idIdentity && !validateTWID(formData.idIdentity.trim())) {
      newErrors.idIdentity = "請輸入正確的身分證號碼";
      formValid = false;
    }
    if (formData.tax_num && !taxIdRegex.test(formData.tax_num)) {
      newErrors.tax_num = "統一編號需為 8 位數字";
      formValid = false;
    }
    
    setErrors(newErrors);
    if (!formValid) return;

    // 儲存到 localStorage 前：若是 CPE，就用主 email 帶入 cpe_email（避免後續相依壞掉）
    const normalizedForm = {
      ...formData,
      ...(productType === "CPE" ? { cpe_email: formData.email || "" } : {}),
    };
    localStorage.setItem("formData", JSON.stringify(normalizedForm));

    // 傳給後端（你原本行為）
    const payload = {
      ...normalizedForm,
      mem_id,
      // 後端若需要字串，這裡也轉成逗號字串
      course: Array.isArray(formData.course) ? formData.course.join(",") : "",
      book: Array.isArray(formData.book) ? formData.book.join(",") : "",
      info_way: Array.isArray(formData.info_way) ? formData.info_way.join(",") : "",
      bridge_courses: Array.isArray(formData.bridge_courses) ? formData.bridge_courses.join(",") : "",
      ut_reasons: Array.isArray(formData.ut_reasons) ? formData.ut_reasons.join(",") : "",
      product_type: productType,
      cpa_addons: Array.isArray(formData.cpa_addons) ? formData.cpa_addons.join(",") : "",
      chinese_class_option: formData.chinese_class_option || "",
      chinese_inperson_subjects: Array.isArray(formData.chinese_inperson_subjects) ? formData.chinese_inperson_subjects.join(",") : "",
    };

    try {
      await axios.post(`${backend}member/payinfo`, payload, {
      headers: { "Content-Type": "application/json" },
      });
      setStep(3);
      localStorage.setItem("paymentStep", "3");
      navigate("/registration/pay", { replace: true });
    } catch (error) {
      console.error("更新會員資料失敗：", error.response?.data || error.message);
    }
  };

  // ===== UT 選項清單 =====
  const UT_REASONS = [
    { val: "prep_cpa", label: "為未來準備美國 CPA 考試做預習" },
    { val: "prep_ea",  label: "為未來準備美國 EA 考試做預習" },
    { val: "work_fast",label: "工作與美稅有關，希望短期快速理解美稅全盤概念" },
    { val: "interest", label: "對美國稅務有興趣，希望自學充實相關知識" },
  ];

  return (
    <>
      <div className="container mb100 mt100">
        <div className="beckertitlename mt100 mb-5">請填購買資料</div>
        <div className="card w-75 p-5 m-auto">
          <div className="card-body">
            <form>
              {/* ===== 基本資料 ===== */}
              <div className="form-group mb-4">
                <label htmlFor="name" className="mb-2">*中文全名</label>
                <input
                  className={`form-control ${errors.name && "is-invalid"}`}
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
              </div>

              <div className="form-group mb-4">
                <label className="mb-2">*英文拼音全名</label><br />
                <div className="row">
                  <div className="col">
                    <input
                      type="text"
                      className={`form-control ${errors.fname && "is-invalid"}`}
                      placeholder="First name"
                      value={formData.fname}
                      onChange={(e) => setFormData({ ...formData, fname: e.target.value })}
                    />
                    {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                  </div>
                  <div className="col">
                    <input
                      type="text"
                      className={`form-control ${errors.lname && "is-invalid"}`}
                      placeholder="Last name"
                      value={formData.lname}
                      onChange={(e) => setFormData({ ...formData, lname: e.target.value })}
                    />
                    {errors.lname && <div className="invalid-feedback">{errors.lname}</div>}
                  </div>
                </div>
                <small id="enameHelp" className="form-text text-muted">同護照上顯示之英文名，例：Da-Ming, Wang</small>
              </div>

              <div className="form-group mb-4">
                <label htmlFor="phone" className="mb-2">*聯絡電話</label>
                <input
                  type="tel"
                  className={`form-control ${errors.phone && "is-invalid"}`}
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                />
                {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
              </div>

              <div className="form-group mb-4">
                <label htmlFor="email" className="mb-2">*電子郵件</label>
                <input
                  type="email"
                  className={`form-control ${errors.email && "is-invalid"}`}
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    {productType !== "CPE" && (
                      <small id="emailHelp" className="form-text text-muted">
                        將依此註冊您的 Becker 教材帳號。若您曾經購買或試用過任何 Becker 產品，請提供「尚未用來註冊過 Becker」的電子郵件住址
                      </small>
                    )}
              </div>

              <div className="form-group mb-4">
                <label htmlFor="idIdentity" className="mb-2">*身分證字號</label>
                <input
                  type="text"
                  className={`form-control ${errors.idIdentity && "is-invalid"}`}
                  id="idIdentity"
                  name="idIdentity"
                  value={formData.idIdentity}
                  onChange={(e) => setFormData({ ...formData, idIdentity: e.target.value })}
                />
                {errors.idIdentity && <div className="invalid-feedback">{errors.idIdentity}</div>}
                {!isCIA && (<small id="idHelp" className="form-text text-muted">將依此註冊您的中文「雲端導讀與解題」觀看帳號</small>)}
              </div>

              <div className="form-group mb-4">
                <label htmlFor="school" className="mb-2">*所屬(或畢業)學校</label>
                <input
                  type="text"
                  className={`form-control ${errors.school && "is-invalid"}`}
                  id="school"
                  value={formData.school}
                  onChange={(e) => setFormData({ ...formData, school: e.target.value })}
                />
                {errors.school && <div className="invalid-feedback">{errors.school}</div>}
              </div>

              <div className="form-group mb-4">
                <label htmlFor="major" className="mb-2">*科系</label>
                <input
                  type="text"
                  className={`form-control ${errors.major && "is-invalid"}`}
                  id="major"
                  value={formData.major}
                  onChange={(e) => setFormData({ ...formData, major: e.target.value })}
                />
                {errors.major && <div className="invalid-feedback">{errors.major}</div>}
              </div>

              <div className="form-group mb-4">
                <label className="mb-2">*目前職業</label>
                <select
                  className={`form-control ${errors.status && "is-invalid"}`}
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                >
                  <option value="" disabled>請選擇職業</option>
                  <option value="incumbent">在職者</option>
                  <option value="student">在學生</option>
                  <option value="candidates">全職考生</option>
                  <option value="unemployed">待業中</option>
                </select>
                {errors.status && <div className="invalid-feedback">{errors.status}</div>}
              </div>

              {/* ===== CMA 額外欄位（沿用） ===== */}
              {isCMA && (
                <>
                  <div className="form-group mb-4">
                    <label className="mb-2">*所屬產業</label>
                    <select
                      className={`form-control ${errors.industry && "is-invalid"}`}
                      value={formData.industry}
                      onChange={(e) => setFormData({ ...formData, industry: e.target.value })}
                    >
                      <option value="" disabled>請選擇職業</option>
                      <option value="student">在學中，尚無所屬產業</option>
                      <option value="account">會計師事務所</option>
                      <option value="investment">投資銀行業</option>
                      <option value="financial">其他金融業</option>
                      <option value="manufacturing">製造業</option>
                      <option value="electronics">電子業</option>
                      <option value="other">其他</option>
                    </select>
                    {errors.industry && <div className="invalid-feedback">{errors.industry}</div>}
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*在職者工作年資</label>
                    <input
                      type="text"
                      className={`form-control ${errors.workyear && "is-invalid"}`}
                      id="workyear"
                      placeholder="若仍為學生，請填「0」"
                      value={formData.workyear}
                      onChange={(e) => setFormData({ ...formData, workyear: e.target.value })}
                    />
                    {errors.workyear && <div className="invalid-feedback">{errors.workyear}</div>}
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*在職者職稱</label>
                    <input
                      type="text"
                      className={`form-control ${errors.jobtitle && "is-invalid"}`}
                      id="jobtitle"
                      placeholder="若為在學生，請填 n/a。"
                      value={formData.jobtitle}
                      onChange={(e) => setFormData({ ...formData, jobtitle: e.target.value })}
                    />
                    {errors.jobtitle && <div className="invalid-feedback">{errors.jobtitle}</div>}
                  </div>

                  {/* 這一題改成只有「非 CPE」才顯示 */}
                  {productType !== "CPE" && (
                    <div className="form-group mb-4">
                      <label className="mb-2">*取得認證之職涯規劃</label>
                      <input
                        type="text"
                        className={`form-control ${errors.reason && "is-invalid"}`}
                        id="reason"
                        placeholder="請簡述考取證照的原因。"
                        value={formData.reason}
                        onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                      />
                      {errors.reason && <div className="invalid-feedback">{errors.reason}</div>}
                    </div>
                  )}
                </>
              )}

              {/* ===== CPE 額外欄位 ===== */}
              {productType === "CPE" && (
                <>

                  <div className="form-group mb-4">
                  <label className="mb-2">
                    您的 CPE Select 方案將於購買後七個工作天內啟用，Becker Taiwan 寄送「購買確認信」該日為您的啟用日。
                  </label>

                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="cpe-activation-confirm"
                      className={`form-check-input ${errors.cpe_activation_confirm ? "is-invalid" : ""}`}
                      checked={!!formData.cpe_activation_confirm}
                      onChange={(e) =>
                        setFormData(prev => {
                          const next = { ...prev, cpe_activation_confirm: e.target.checked };
                          localStorage.setItem("formData", JSON.stringify(next));
                          return next;
                        })
                      }
                    />
                    <label className="form-check-label" htmlFor="cpe-activation-confirm">
                      *我已了解並同意上述啟用說明
                    </label>
                    {errors.cpe_activation_confirm && (
                      <div className="invalid-feedback d-block">
                        {errors.cpe_activation_confirm}
                      </div>
                    )}
                  </div>

                  <small className="form-text text-muted">
                    啟用日起一年內可使用 Select 方案所有課程。
                  </small>
                </div>


                  <div className="form-group mb-4">
                    <label className="mb-2">*所屬公司行號名稱（Company Name）</label>
                    <input
                      type="text"
                      className={`form-control ${errors.cpe_company_name && "is-invalid"}`}
                      placeholder="向 Becker 註冊 CPE 帳號時須註明之公司名稱"
                      value={formData.cpe_company_name}
                      onChange={(e) => setFormData({ ...formData, cpe_company_name: e.target.value })}
                    />
                    {errors.cpe_company_name && <div className="invalid-feedback">{errors.cpe_company_name}</div>}
                  </div>
                </>
              )}

              {/* ===== UT（parent_id=6）專屬欄位 ===== */}
              {productType === "UT" && (
                <>
                  <hr />
                  <div className="form-group mb-4">
                    <label className="mb-2">*指定課程啟用日（重要！）</label>
                    <input
                      type="date"
                      className={`form-control ${errors.ut_activation_date && "is-invalid"}`}
                      value={formData.ut_activation_date}
                      onChange={(e) => setFormData({ ...formData, ut_activation_date: e.target.value })}
                    />
                    {errors.ut_activation_date && <div className="invalid-feedback">{errors.ut_activation_date}</div>}
                    <small className="form-text text-muted">
                      請指定「購買日後一個月內」的日子。課程將於指定日開始提供線上看課，並依方案有效期間計算。
                    </small>
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*選購課程的原因（可複選）</label>
                    <div className="custom-control custom-checkbox mb-2">
                      {UT_REASONS.map(r => (
                        <div key={r.val} className="form-check form-check-inline">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`ut-reason-${r.val}`}
                            value={r.val}
                            checked={Array.isArray(formData.ut_reasons) && formData.ut_reasons.includes(r.val)}
                            onChange={handleUTReasonChange}
                          />
                          <label className="custom-control-label m-2" htmlFor={`ut-reason-${r.val}`}>
                            {r.label}
                          </label>
                        </div>
                      ))}
                    </div>
                    {errors.ut_reasons && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.ut_reasons}
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* ===== 學分班（Bridging Program）額外欄位 ===== */}
              {productType === "BRIDGE" && (
                <>
                  <hr />
                  <div className="form-group mb-4">
                    <label className="mb-2">*Becker 學員西元出生年月日</label>
                    <input
                      type="date"
                      className={`form-control ${errors.bridge_birthdate && "is-invalid"}`}
                      value={formData.bridge_birthdate}
                      onChange={(e) => setFormData({ ...formData, bridge_birthdate: e.target.value })}
                    />
                    {errors.bridge_birthdate && <div className="invalid-feedback">{errors.bridge_birthdate}</div>}
                    <small className="form-text text-muted">供 CSUEB 美國校方註冊使用</small>
                  </div>

                  <div className="form-group mb-4">
                    <label className="mb-2">*選擇合作學分班課程（可複選）</label>
                    <div className="custom-control custom-checkbox mb-2">
                      {bridgeCourseOptions.map(opt => (
                        <div key={opt.id} className="form-check form-check-inline">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`csu-${opt.id}`}
                            value={opt.id}
                            checked={(formData.bridge_courses || []).map(String).includes(opt.id)}
                            onChange={handleBridgeCourseChange}
                          />
                          <label className="custom-control-label m-2" htmlFor={`csu-${opt.id}`}>
                            {opt.label}
                          </label>
                        </div>
                      ))}
                    </div>
                    {errors.bridge_courses && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.bridge_courses}
                      </div>
                    )}
                  </div>
                </>
              )}
              {/* ===== 舊生續購（RP）額外欄位 ===== */}
              {productType === "RP" && (
                <>
                  <hr />

                  {/* (1) 加購項目 */}
                  <div className="form-group mb-4">
                    <label className="mb-2">*選擇 Becker CPA 其他加購項目</label>

                    <div className="custom-control custom-checkbox mb-2">
                      {cpaAddonOptions.map(opt => (
                        <div key={opt.id} className="form-check form-check-inline">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`rp-addon-${opt.id}`}
                            value={opt.id}
                            checked={Array.isArray(formData.cpa_addons) && formData.cpa_addons.map(String).includes(String(opt.id))}
                            onChange={handleCpaAddonChange}
                          />
                          <label className="custom-control-label m-2" htmlFor={`rp-addon-${opt.id}`}>
                            {opt.label}
                          </label>
                        </div>
                      ))}
                    </div>

                    {errors.cpa_addons && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.cpa_addons}
                      </div>
                    )}
                  </div>

                  {/* (2) 中文面授班科目 */}
                  <div className="form-group mb-4">
                    <label className="mb-2">2. 所購科目中，欲加入中文面授班的科目：</label>
                    <div className="form-text text-muted mb-2" style={{ lineHeight: 1.6 }}>
                      * 勾選欲參加中文面授者，我們將儘快與您確認進班時間與是否為候補狀態。
                    </div>

                    {/* 三選一 */}
                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="chinese_class_option"
                        id="rp-chinese-inperson"
                        value="inperson"
                        checked={formData.chinese_class_option === "inperson"}
                        onChange={handleChineseClassOptionChange}
                      />
                      <label className="form-check-label" htmlFor="rp-chinese-inperson">
                        （請勾選下方科目）我要進班參加面授
                      </label>
                    </div>

                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="chinese_class_option"
                        id="rp-chinese-selfstudy"
                        value="selfstudy_no_access"
                        checked={formData.chinese_class_option === "selfstudy_no_access"}
                        onChange={handleChineseClassOptionChange}
                      />
                      <label className="form-check-label" htmlFor="rp-chinese-selfstudy">
                        無，選擇「自修方案 (舊生)」，無含中文課程使用權。
                      </label>
                    </div>

                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="chinese_class_option"
                        id="rp-chinese-digital"
                        value="digital_only"
                        checked={formData.chinese_class_option === "digital_only"}
                        onChange={handleChineseClassOptionChange}
                      />
                      <label className="form-check-label" htmlFor="rp-chinese-digital">
                        無，我要以數位方式觀看中文課程，不進班參加面授。
                      </label>
                    </div>

                    {errors.chinese_class_option && (
                      <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                        {errors.chinese_class_option}
                      </div>
                    )}

                    {/* 選 inperson 才出現科目勾選 */}
                    {formData.chinese_class_option === "inperson" && (
                      <div className="mt-3">
                        <div className="custom-control custom-checkbox mb-2">
                          {chineseInpersonSubjects.map(opt => (
                            <div key={opt.id} className="form-check form-check-inline">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`rp-chinese-subject-${opt.id}`}
                                value={opt.id}
                                checked={Array.isArray(formData.chinese_inperson_subjects) &&
                                  formData.chinese_inperson_subjects.map(String).includes(String(opt.id))}
                                onChange={handleChineseInpersonSubjectChange}
                              />
                              <label className="custom-control-label m-2" htmlFor={`rp-chinese-subject-${opt.id}`}>
                                {opt.label}
                              </label>
                            </div>
                          ))}
                        </div>

                        {errors.chinese_inperson_subjects && (
                          <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                            {errors.chinese_inperson_subjects}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* ===== CPA / CMA / EA：共用加購判斷 ===== */}
              {(isCPA || isCMA || isEA) && (
                <>
                  <div className="form-group mb-4">
                    <label className="mb-2">*是否需加購紙本教科書？</label>
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        id="addbook-yes"
                        name="addbook"
                        className="custom-control-input"
                        checked={!!showCourses}
                        onChange={() => handleAddBookToggle(true)}
                      />
                      <label className="custom-control-label" htmlFor="addbook-yes">是</label>
                    </div>
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        id="addbook-no"
                        name="addbook"
                        className="custom-control-input"
                        checked={!showCourses}
                        onChange={() => handleAddBookToggle(false)}
                      />
                      <label className="custom-control-label" htmlFor="addbook-no">否</label>
                    </div>
                  </div>
            
                  {showCourses && (
                    <>
                      {/* --- CPA：維持原本的書單與快遞 --- */}
                      {isCPA && (
                        <div className="form-group mb-4">
                          <label className="mb-2">（承上題）欲加購哪些科目？ 每本價錢 $2,500元</label>
                          <div className="custom-control custom-checkbox mb-2">
                            {["AUD", "FAR", "REG", "專科書本"].map((subject) => {
                              const checked = Array.isArray(formData.book) ? formData.book.includes(subject) : false;
                              return (
                                <div key={subject} className="form-check form-check-inline">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`book-${subject}`}
                                    value={subject}
                                    checked={checked}
                                    onChange={handleBookChange}
                                  />
                                  <label className="custom-control-label m-2" htmlFor={`book-${subject}`}>
                                    {subject}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                          {errors.book && (
                            <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                              {errors.book}
                            </div>
                          )}
            
                          <label className="mb-2">*是否需快遞？</label>
                          <div className={`custom-control custom-radio ${errors.deliver ? "is-invalid" : ""}`}>
                            <input
                              type="radio"
                              id="deliver-yes"
                              name="deliverOption"
                              value="快遞"
                              className="custom-control-input"
                              checked={Array.isArray(formData.deliver) && formData.deliver.includes("快遞")}
                              onChange={() => handleDeliverChange("快遞")}
                            />
                            <label className="custom-control-label" htmlFor="deliver-yes">是</label>
                          </div>
                          <div className={`custom-control custom-radio ${errors.deliver ? "is-invalid" : ""}`}>
                            <input
                              type="radio"
                              id="deliver-no"
                              name="deliverOption"
                              value="自取"
                              className="custom-control-input"
                              checked={Array.isArray(formData.deliver) && formData.deliver.includes("自取")}
                              onChange={() => handleDeliverChange("自取")}
                            />
                            <label className="custom-control-label" htmlFor="deliver-no">否</label>
                          </div>
                          <small id="bookHelp" className="form-text text-muted">
                            快遞計費方式：單箱最多可裝 2 科書籍，每箱快遞費 TWD 100 元。
                          </small>
                        </div>
                      )}
            
                      {/* --- EA：只顯示書單（無快遞/自取） --- */}
                      {isEA && (
                        <div className="form-group mb-4">
                          <label className="mb-2">（承上題）欲加購哪些科目？ 每本價錢 $2,500元</label>
                          <div className="custom-control custom-checkbox mb-2">
                            {["EA-part1", "EA-part2", "EA-part3"].map((subject) => {
                              const checked = Array.isArray(formData.book) ? formData.book.includes(subject) : false;
                              return (
                                <div key={subject} className="form-check form-check-inline">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`book-${subject}`}
                                    value={subject}
                                    checked={checked}
                                    onChange={handleBookChange}
                                  />
                                  <label className="custom-control-label m-2" htmlFor={`book-${subject}`}>
                                    {subject}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
            
                      {/* --- CMA：只顯示書單（無快遞/自取） --- */}
                      {isCMA && (
                        <div className="form-group mb-4">
                          <label className="mb-2">（承上題）欲加購哪些科目？ 每本價錢 $2,500元</label>
                          <div className="custom-control custom-checkbox mb-2">
                            {["CMA-part1", "CMA-part2"].map((subject) => {
                              const checked = Array.isArray(formData.book) ? formData.book.includes(subject) : false;
                              return (
                                <div key={subject} className="form-check form-check-inline">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`book-${subject}`}
                                    value={subject}
                                    checked={checked}
                                    onChange={handleBookChange}
                                  />
                                  <label className="custom-control-label m-2" htmlFor={`book-${subject}`}>
                                    {subject}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}

              <div className="form-group mb-4">
                <label htmlFor="address" className="mb-2">*發票/紙本教科書郵寄地址</label>
                <Address
                  onAddressChange={(combinedAddress) => {
                    const next = { ...formData, address: combinedAddress };
                    setFormData(next);
                    localStorage.setItem("formData", JSON.stringify(next));
                  }}
                />
                {errors.address && (
                  <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                    {errors.address}
                  </div>
                )}
              </div>

              <div className="form-group mb-4">
                <label className="mb-2">發票開立統一編號與抬頭</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  id="tax_num"
                  placeholder="統一編號"
                  pattern="[0-9]*" 
                  maxLength={8} 
                  inputMode="numeric" 
                  value={formData.tax_num}
                  onChange={(e) => setFormData({ ...formData, tax_num: e.target.value })}
                />
                {errors.tax_num && (
                  <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                    {errors.tax_num}
                  </div>
                )}
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  placeholder="公司抬頭"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                />
                <small id="invoiceHelp" className="form-text text-muted">留白則為一般二聯式發票</small>
              </div>
              {!isCIA && (
                <div className="form-group mb-4">
                  <label className="mb-2">*選擇上課方式：</label><br />
                  <small className="form-text text-muted">依照個人需求，可複選。</small>

                  {allowOnsite ? (
                  // ===== CPA / EA：現場面授＋雲端教室 =====
                  <div className="custom-control custom-checkbox mb-2">
                    <div className="form-check form-check-inline">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="course-onsite"
                        value="現場面授"
                        checked={Array.isArray(formData.course) && formData.course.includes("現場面授")}
                        onChange={handleCourseSelection}
                      />
                      <label className="custom-control-label m-2" htmlFor="course-onsite">
                        現場面授
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="course-online"
                        value="雲端教室"
                        checked={Array.isArray(formData.course) && formData.course.includes("雲端教室")}
                        onChange={handleCourseSelection}
                      />
                      <label className="custom-control-label m-2" htmlFor="course-online">
                        雲端教室（線上看課）
                      </label>
                    </div>
                  </div>
                ) : (
                  // ===== 其他（CMA、CPE、BRIDGE、UT）：只提供雲端教室 =====
                  <div className="custom-control custom-checkbox mb-2">
                    <div className="form-check form-check-inline">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="course-online-only"
                        value="雲端教室"
                        checked={Array.isArray(formData.course) && formData.course.includes("雲端教室")}
                        onChange={handleCourseSelection}
                      />
                      <label className="custom-control-label m-2" htmlFor="course-online-only">
                        雲端教室
                      </label>
                    </div>
                  </div>
                )}


                  {errors.course && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                      {errors.course}
                    </div>
                  )}
                </div>
              )}

              <label className="mb-2">*您是從何處得知 Becker Taiwan (捷進)</label>
              <div className="custom-control custom-checkbox mb-2">
                {[
                  ["google", "Google"],
                  ["facebook", "Facebook"],
                  ["instagram", "Instagram"],
                  ["line", "LINE"],
                  ["edm", "EDM"],
                  ["親友同事介紹", "親友同事介紹"],
                  ["校園講座", "校園講座"],
                  ["事務所內部宣傳", "事務所內部宣傳"],
                  ["捷運廣告", "捷運廣告"],
                  ["企業內部宣傳", "企業內部宣傳"],
                  ["IMA 協會台北分會", "IMA 協會台北分會"],
                ].map(([val, label]) => (
                  <div key={val} className="form-check form-check-inline">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id={val}
                      value={val}
                      onChange={handleinfoChange}
                      checked={Array.isArray(formData.info_way) && formData.info_way.includes(val)}
                    />
                    <label className="custom-control-label m-2" htmlFor={val}>{label}</label>
                  </div>
                ))}
              </div>
              {errors.info_way && (
                <div className="text-danger mt-1" style={{ fontSize: "0.9rem" }}>
                  {errors.info_way}
                </div>
              )}

              <button type="submit" className="btn btn-primary" onClick={handleSubmit}>送出</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Payinfo;
